var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDodecagonCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4683 15.4986C29.4683 14.1638 31.288 12.5933 30.9588 11.3564C30.6162 10.0772 28.247 9.63455 27.5996 8.51335C26.9522 7.39215 27.7353 5.10748 26.8121 4.18427C25.8889 3.26106 23.622 4.05747 22.483 3.39899C21.344 2.74051 20.9258 0.382426 19.6422 0.0398376C18.4053 -0.289403 16.8414 1.53032 15.5 1.53032C14.1586 1.53032 12.5947 -0.289403 11.3578 0.0398376C10.0786 0.382426 9.63595 2.75163 8.51475 3.39899C7.39355 4.04635 5.10888 3.26328 4.18568 4.18649C3.26247 5.1097 4.05887 7.37657 3.40039 8.51557C2.74191 9.65457 0.383832 10.0728 0.0412431 11.3564C-0.294672 12.5933 1.53173 14.1638 1.53173 15.4986C1.53173 16.8334 -0.287998 18.4039 0.0412431 19.6408C0.383832 20.9199 2.75303 21.3626 3.40039 22.4838C4.04775 23.605 3.26469 25.8897 4.1879 26.8129C5.11111 27.7361 7.37798 26.9397 8.51697 27.5982C9.65597 28.2567 10.0742 30.6148 11.3578 30.9573C12.5947 31.2866 14.1586 29.4669 15.5 29.4669C16.8414 29.4669 18.4053 31.2866 19.6422 30.9573C20.9214 30.6148 21.364 28.2456 22.4852 27.5982C23.6064 26.9508 25.8911 27.7339 26.8143 26.8107C27.7375 25.8875 26.9411 23.6206 27.5996 22.4816C28.2581 21.3426 30.6162 20.9244 30.9588 19.6408C31.2947 18.4039 29.4683 16.8334 29.4683 15.4986Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_165436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4893 15.4355L14.1969 19.1431L21.6123 11.7278",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_165436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7968,
    height: 17.7968,
    fill: "white",
    transform: "translate(6.78162 6.53711)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDodecagonCheck);
export default __webpack_public_path__ + "static/media/dodecagon-check.dd87a01eb90c4066d499295e20cedd02.svg";
export { ForwardRef as ReactComponent };